// Web Audio API sound generator for focus completion tones.
// No external audio files needed — everything synthesized in-browser.

let _ctx = null;
function ctx() {
  if (_ctx) return _ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  _ctx = new AC();
  return _ctx;
}

function playTone({ freq, duration = 0.9, type = "sine", volume = 0.15, attack = 0.02, release = 0.6 }) {
  const c = ctx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  const now = c.currentTime;
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(volume, now + attack);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + duration + release);
  osc.connect(gain);
  gain.connect(c.destination);
  osc.start(now);
  osc.stop(now + duration + release + 0.05);
}

function playInkDrop() {
  // Soft low bloom + gentle wobble — like a brush touching paper.
  playTone({ freq: 220, duration: 0.35, type: "sine", volume: 0.18, attack: 0.005, release: 0.9 });
  setTimeout(() => playTone({ freq: 165, duration: 0.6, type: "sine", volume: 0.1, attack: 0.02, release: 1.2 }), 60);
}

function playWindChime() {
  // Three ascending overtones with slight stagger.
  const notes = [523.25, 659.25, 783.99]; // C5, E5, G5
  notes.forEach((f, i) => setTimeout(() => playTone({ freq: f, duration: 0.4, type: "triangle", volume: 0.11, attack: 0.005, release: 1.4 }), i * 90));
}

function playSoftBell() {
  // Rounded fundamental + gentle harmonic tail.
  playTone({ freq: 587.33, duration: 0.5, type: "sine", volume: 0.14, attack: 0.005, release: 1.6 });
  setTimeout(() => playTone({ freq: 880, duration: 0.35, type: "sine", volume: 0.08, attack: 0.01, release: 1.3 }), 40);
}

export function playCompletionSound(choice) {
  try {
    switch (choice) {
      case "ink_drop": return playInkDrop();
      case "wind_chime": return playWindChime();
      case "soft_bell": return playSoftBell();
      case "silent":
      default: return;
    }
  } catch { /* no-op */ }
}
